import {ProcessFlowchartNodeDetailsType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {
  ProcessFlowchartTaskNode,
  ProcessFlowchartOutputNode,
} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartNodeDetailType';
import {ProcessFlowchartInteractiveNode} from 'processes/graph-builder-processes/flowchart-viz/ProcessFlowchartVizConstants';

const NODE_DETAIL_TYPES_WITH_INBOUND_SCHEMA_MAPPER_CONFIGS = [
  ProcessFlowchartNodeDetailsType.TASK_NODE_DETAILS,
  ProcessFlowchartNodeDetailsType.OUTPUT_NODE_DETAILS,
];

export function isNodeWithInboundSchemaMappers(
  node: ProcessFlowchartInteractiveNode
): node is ProcessFlowchartTaskNode | ProcessFlowchartOutputNode {
  return NODE_DETAIL_TYPES_WITH_INBOUND_SCHEMA_MAPPER_CONFIGS.includes(node.type);
}
